console.log("bundle is connected");

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
